import axios from "axios";
import { Config } from "config";

export const postRating = (args) => {
    return axios.post(`${Config.MyDNV.azureFnPath}/postRating`, args, {
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};

export const getLastRating = (args) => {
    return axios.get(`${Config.MyDNV.azureFnPath}/getLastRating`, {
        headers: {
            Authorization: `Bearer ${args}`,
            "Content-Type": "application/json",
        },
    });
};
